module.exports = __webpack_public_path__ + "static/media/ZUMBAS.469045c8.png";